import styled, { css, DefaultTheme } from 'styled-components';
import { tagSizesList, TTagSize, TTagVariant } from './status-badge.types';

const prefixCls = 'ui-status';

export const statusClasses = {
  component: prefixCls,
  dot: `${prefixCls}-dot`,
  label: `${prefixCls}-label`,
} as const;

export const DOT_SIZE_MAP: Record<TTagSize, { width: number; height: number }> = {
  small: {
    width: 8,
    height: 8,
  },
  medium: {
    width: 12,
    height: 12,
  },
  large: {
    width: 16,
    height: 16,
  },
};

export function getTagColor(theme: DefaultTheme, variant: TTagVariant) {
  switch (variant) {
    case 'success':
      return theme.color.tint.success;
    case 'danger':
      return theme.color.solid.error;
    case 'default':
      return theme.color.tint.tertiary;
    case 'warning':
      return theme.color.tint.warning;
    case 'info':
      return theme.color.solid.info;
    default:
      return theme.color[variant][50];
  }
}

function generateTagsSizes() {
  let ret = '';

  for (const size of tagSizesList) {
    ret += `
      &.${prefixCls}-${size} {
        .${statusClasses.dot} {
          width: ${DOT_SIZE_MAP[size].width}px;
          min-width: ${DOT_SIZE_MAP[size].width}px;
          max-width: ${DOT_SIZE_MAP[size].width}px;
          height: ${DOT_SIZE_MAP[size].height}px;
          min-height: ${DOT_SIZE_MAP[size].height}px;
          max-height: ${DOT_SIZE_MAP[size].height}px;
          border-radius: 50%;
        }
      }
    `;
  }

  return ret;
}

const tagSizes = generateTagsSizes();

export const StatusBadgeSC = styled.span<{ color: string }>`
  display: inline-flex;
  align-items: center;

  &.${prefixCls}-small {
    .${statusClasses.label} {
      ${({ theme }) => theme.mappedTypography.captionSmall.default};
    }
  }

  &.${prefixCls}-medium {
    .${statusClasses.label} {
      ${({ theme }) => theme.mappedTypography.captionLarge.default};
    }
  }

  &.${prefixCls}-large {
    .${statusClasses.label} {
      ${({ theme }) => theme.mappedTypography.body2.strong};
    }
  }

  .${statusClasses.dot} {
    background-color: ${({ color }) => color};
  }

  .${statusClasses.label} {
    width: 100%;
    margin-left: 8px;

    &.${`${statusClasses.label}-color`} {
      color: ${({ color }) => color};
    }
  }

  ${tagSizes};
`;
